// extracted by mini-css-extract-plugin
export default {"colorTray":"ColorTray__colorTray___aqwAz","colorDropContainer":"ColorTray__colorDropContainer___KZjSU","skeleton-loading":"ColorTray__skeleton-loading___xikbd"};